module.exports = __webpack_public_path__ + "img/61d3f358c8affd2589691c4713d521f7.png";